import React from 'react';
import ChartForm from "./ChartForm";
import {useSelector} from "react-redux";

const Chart = () => {
    const {userLanguage} = useSelector(state => state.app);
    return (
        <div>
            <ChartForm
                userLanguage={userLanguage}
            />
        </div>
    )
}
export default Chart;